import { render, staticRenderFns } from "./fbaChannelEditDialog.vue?vue&type=template&id=c0369ec4&"
import script from "./fbaChannelEditDialog.vue?vue&type=script&lang=js&"
export * from "./fbaChannelEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./fbaChannelEditDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0369ec4')) {
      api.createRecord('c0369ec4', component.options)
    } else {
      api.reload('c0369ec4', component.options)
    }
    module.hot.accept("./fbaChannelEditDialog.vue?vue&type=template&id=c0369ec4&", function () {
      api.rerender('c0369ec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FBA/Channel/fbaChannelEditDialog.vue"
export default component.exports